import { Component, EventEmitter, Host, Input, Optional, Output } from '@angular/core';
import { WorkshopJobcardListCustomerItemsComponent } from './workshop-jobcard-list-customer-items/workshop-jobcard-list-customer-items.component';
import { WorkshopJobcardAddCustomerItemComponent } from './workshop-jobcard-add-customer-item/workshop-jobcard-add-customer-item.component';
import { WorkshopJobcardUpdateCustomerItemComponent } from './workshop-jobcard-update-customer-item/workshop-jobcard-update-customer-item.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services/helpers.service';
import { GearManagementService } from 'src/app/services/gear-management.service';
import { AppConfig } from 'src/app/app.config';
import { WorkshopJobcardAccordionComponent } from '../workshop-jobcard-accordion/workshop-jobcard-accordion.component';

@Component({
  selector: 'app-workshop-jobcard-item-details',
  templateUrl: './workshop-jobcard-item-details.component.html',
  styleUrls: ['./workshop-jobcard-item-details.component.scss']
})
export class WorkshopJobcardItemDetailsComponent {
  @Input() jobcard: any;
  @Input() jobCards: any[] = []; // New input for job cards
  @Output() jobcardChange = new EventEmitter<any>();

  itemTypes: any[] = [];

  constructor(
    private modalService: NgbModal,
    private translate: TranslateService,
    private helpersService: HelpersService,
    private appConfig: AppConfig,
    private gearService: GearManagementService,
    @Optional() @Host() private parentComponent: WorkshopJobcardAccordionComponent
  ) { }

  ngOnInit() {
    this.getBikeTypes();
  }

  getBikeTypes() {
    this.gearService.getBikeTypes().subscribe((types) => {
      this.itemTypes = types.map((x) => {
        return { value: x.id, label: this.translate.instant(x.label) };
      });
    });
  }


  showCustomerItems() {
    const modalRef = this.modalService.open(WorkshopJobcardListCustomerItemsComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xl'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.jobCards = this.jobCards; 

    modalRef.result.then(
      (result) => {
        console.log('Modal closed with result:', result);
        if (result.action === 'edit') {
          this.updateItem(result.selectedItem);
        } else if (result.action === 'create') {
          this.addItem();
        } else if (result.action === 'delete') {

        } else if (result.selectedItem && result.selectedItem.id > 0) {
          this.jobcard.selectedItem = result.selectedItem;
          this.jobcardChange.emit({ ...this.jobcard });
          this.closeAndOpenSections();
        }
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

  addItem() {
    const modalRef = this.modalService.open(WorkshopJobcardAddCustomerItemComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'lg'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.partnerType = this.appConfig.getPartnerType();
    modalRef.componentInstance.partnerTypeID = this.helpersService.getPartnerData().PartnerType;
    modalRef.componentInstance.itemTypes = this.itemTypes;

    modalRef.result.then(
      (result) => {
        if (result.selectedItem && result.selectedItem.id > 0) {
          this.jobcard.selectedItem = result.selectedItem;
          this.jobcardChange.emit({ ...this.jobcard });
          this.closeAndOpenSections();
        }
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

  updateItem(item) {
    const modalRef = this.modalService.open(WorkshopJobcardUpdateCustomerItemComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'lg'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.item = { ...item };
    modalRef.componentInstance.partnerType = this.appConfig.getPartnerType();
    modalRef.componentInstance.partnerTypeID = this.helpersService.getPartnerData().PartnerType;
    modalRef.componentInstance.itemTypes = this.itemTypes;

    modalRef.result.then(
      (result) => {
        if (result.selectedItem && result.selectedItem.id > 0) {
          this.jobcard.selectedItem = result.selectedItem;
          this.jobcardChange.emit({ ...this.jobcard });
        }
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

  clearItem() {
    this.jobcard.selectedItem = null;
    this.jobcardChange.emit({ ...this.jobcard });
  }

  closeAndOpenSections() {
    if (this.parentComponent) {
      this.parentComponent.closeSection('customer-details');
      this.parentComponent.closeSection('item-details');
      this.parentComponent.openSection('services-products');
    }
  }

}
